// Third party
import React from 'react';

// Components
import ComparisonTopBarNavigation from './ComparisonTopBarNavigation';
import ComparisonTopBarNavigationMobile from './ComparisonTopBarNavigationMobile';
import ComparisonTopBarName from './ComparisonTopBarName';
import { ComparisonTopBarNameMenuItem, ComparisonTopBarContactMenuItem, ComparisonTopBarSettingsMenuItem } from './menu-items';
import { CloseButton } from '../../../components/buttons';

// Hooks
import useScreenSize from '@/hooks/useScreenSize';

// Types
import Comparison from '@/types/comparison';

type DefaultHeaderProps = {
  comparison: Comparison;
  isSaving: boolean;
  setComparisonName: (name: string) => void;
  readOnly: boolean;
  getTopBarLeftItems: () => React.ReactNode[];
  getTopBarMidRightItems: () => React.ReactNode[];
  getMobileMenuItems?: () => React.ReactNode[];
  handleComparisonClose: () => void;
};

const ComparisonTopBarNavigationResponsive: React.FC<DefaultHeaderProps> = ({
  comparison,
  isSaving,
  setComparisonName,
  readOnly,
  getTopBarLeftItems,
  getTopBarMidRightItems,
  getMobileMenuItems,
  handleComparisonClose,
}) => {
  const { isDesktop } = useScreenSize();

  const middleItems = [
    <ComparisonTopBarName key={comparison._id} setComparisonName={setComparisonName} comparison={comparison} readOnly={readOnly} isSaving={isSaving} />,
  ];

  // Mobile menu items include the name menu item for the dropdown
  const mobileMenuMiddleItems = [
    <ComparisonTopBarNameMenuItem key={`${comparison._id}-menu`} setComparisonName={setComparisonName} comparison={comparison} readOnly={readOnly} />,
  ];

  const mobileMenuItems = [...(mobileMenuMiddleItems || []), ...((getMobileMenuItems && getMobileMenuItems()) || [])];

  if (!isDesktop) {
    return (
      <ComparisonTopBarNavigationMobile
        leftItems={getTopBarLeftItems()}
        middleItems={middleItems}
        mobileMenuItems={mobileMenuItems}
        onBack={handleComparisonClose}
      />
    );
  }

  const farRightItems = [<CloseButton key="ComparisonTopBarNavigation.CloseButton" dark withText onClick={handleComparisonClose} className="top-bar-button" />];

  return (
    <ComparisonTopBarNavigation
      leftItems={getTopBarLeftItems()}
      middleItems={middleItems}
      midRightItems={getTopBarMidRightItems()}
      farRightItems={farRightItems}
    />
  );
};

export default ComparisonTopBarNavigationResponsive;
